// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addLink-dialog[data-v-7c2865a0]{margin-top:0}.addLink-dialog .content[data-v-7c2865a0]{height:calc(100vh - 300px)!important;overflow:auto}.path-item[data-v-7c2865a0]{width:50%;text-align:left;margin:0 auto}.content-top[data-v-7c2865a0]{text-align:center}.content-top>p[data-v-7c2865a0]{font-size:18px;font-weight:bolder}.content-top .top-text[data-v-7c2865a0]{display:flex;justify-content:center}.content-top .top-text span[data-v-7c2865a0]{margin:0 30px}", ""]);
// Exports
module.exports = exports;
